<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <PageHeader :title="title" :items="items" />
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label class="col-form-label col-form-label-sm" for="ep_id">EP ID</label>
                                <input
                                    type="text"
                                    v-model="search_data.ep_id"
                                    id="ep_id"
                                    name="ep_id"
                                    class="form-control form-control-sm"
                                    placeholder="Search by ep id"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                                <select
                                    v-model="search_data.mouza_id"
                                    class="form-control form-control-sm"
                                    name="mouza_id"
                                    id="mouza_id"
                                >
                                    <option selected :value="''">Select a Mouza</option>
                                    <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id"
                                        >{{ mouza.id }} : {{ mouza.mouza_desc }}</option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label class="col-form-label col-form-label-sm" for="village_id">Village</label>
                                <select
                                    v-model="search_data.village_id"
                                    class="form-control form-control-sm"
                                    name="village_id"
                                    id="village_id"
                                >
                                    <option selected :value="''">Select a Village</option>
                                    <option v-for="(village, index) in villages" :key="index" :value="village.id"
                                        >{{ village.id }} : {{ village.village_desc }}</option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <button @click.prevent="search" class="btn btn-success btn-sm mt-3">Search</button>
                            </div>
                        </div>
                    </form>
                </b-card>

                <b-card>
                    <div v-if="trainees.length > 0" class="row mb-2">
                        <div class="col-md-12">
                            <span class="badge badge-success">Total Search Data Found: {{ trainees.length }}</span>
                            <button
                                type="button"
                                id="export-table"
                                @click="onexport"
                                class="btn btn-success float-right"
                                >Download Excel</button
                            >
                        </div>
                    </div>
                    <div class="table-responsive scrollable-table" style="overflow-x: auto">
                        <table class="table table-centered table-striped" id="titledExcel">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>EP ID</th>
                                    <th>Name</th>
                                    <th>Father Name</th>
                                    <th>Village</th>
                                    <th>Mouza</th>
                                    <th>Rep. Name</th>
                                    <th>Rep. Father/Husband Name</th>
                                    <th>Family Relation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(trainee, index) in trainees" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{
                                        epIdWithPaymentStatus(trainee.ses.ep_id.ep_id, trainee.ses.ep_id.is_paid)
                                    }}</td>
                                    <td>{{ trainee.ses.name }}</td>
                                    <td>{{ trainee.ses.father_husband_name }}</td>
                                    <td>{{ trainee.ses.village.village_desc }}</td>
                                    <td>{{ trainee.ses.mouza.mouza_desc }}</td>
                                    <td>{{ trainee.rep_name ? trainee.rep_name : trainee.ses.name }}</td>
                                    <td>{{
                                        trainee.rep_father_husband_name
                                            ? trainee.rep_father_husband_name
                                            : trainee.ses.father_husband_name
                                    }}</td>
                                    <td>{{
                                        trainee.rep_family_relation
                                            ? trainee.rep_family_relation.family_relation_desc
                                            : 'Self'
                                    }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="loader" class="loader">Loading...</div>
                    <h5 class="text-center text-secondary" v-if="trainees.length == 0 || !flag">
                        No Data Found
                    </h5>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import XLSX from 'xlsx'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
    page: {
        title: 'Trainee List',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: 'Search Trainee',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'Trainee',
                    active: true,
                },
            ],
            trainees: {},
            search_data: {
                ep_id: '',
                village_id: '',
                mouza_id: '',
            },
            all_villages: [],
            mouzas: [],
            trainee: {},
            flag: false,
            loader: false,
        }
    },

    mounted() {
        this.getCodes()
    },
    methods: {
        epIdWithPaymentStatus: epIdWithPaymentStatus,
        getCodes() {
            http.get('api/trainee/codes').then((response) => {
                if (!response.error) {
                    let data = response.data
                    this.all_villages = data.villages
                    this.mouzas = data.mouzas
                }
            })
        },
        search() {
            this.flag = true
            this.loader = true
            http.post('api/trainee/search/view/list', this.search_data).then((response) => {
                if (!response.error) {
                    this.flag = true
                    this.loader = false
                    this.trainees = response.data.trainees
                }
            })
        },
        onexport(evt) {
            var tbl = document.getElementById('titledExcel')
            var wb = XLSX.utils.table_to_book(tbl)
            XLSX.writeFile(wb, 'trainee.xlsx')
        },
    },
    computed: {
        userPermission() {
            return this.$store.state.user
        },
        villages() {
            const mouza_id = this.search_data.mouza_id
            return mouza_id ? this.all_villages.filter((x) => x.mouza_id === mouza_id) : null
        },
    },
    created() {
        this.$store.dispatch('getUserPermission')
    },
}
</script>
<style>
.scrollable-table {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
<style src="vue-select/dist/vue-select.css"></style>
